import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import styles from './MultiCarousel.module.scss'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { StarIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/24/solid'

const MultiCarousel = () => {
	const [centerCardWidth, setCenterCardWidth] = useState(0)
	const centerProfileCardRef = useRef(null)
	const carouselContainerRef = useRef(null)

	const measureCenterCard = useCallback(() => {
		if (centerProfileCardRef.current) {
			const width = centerProfileCardRef.current.getBoundingClientRect().width
			setCenterCardWidth(width)
		}
	}, [])

	useEffect(() => {
		// 최초 마운트 시 한 번만 실행
		const timer = setTimeout(() => {
			measureCenterCard()
		}, 0)

		let observer
		if (centerProfileCardRef.current && 'ResizeObserver' in window) {
			observer = new window.ResizeObserver(measureCenterCard)
			observer.observe(centerProfileCardRef.current)
		}

		window.addEventListener('resize', measureCenterCard)

		return () => {
			clearTimeout(timer)
			window.removeEventListener('resize', measureCenterCard)
			if (observer && centerProfileCardRef.current) {
				observer.unobserve(centerProfileCardRef.current)
			}
		}
	}, [measureCenterCard])

	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 5,
			slidesToSlide: 1, // optional, default to 1.
			partialVisibilityGutter: 16,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 5,
			slidesToSlide: 1, // optional, default to 1.
			partialVisibilityGutter: 16,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 5,
			slidesToSlide: 1, // optional, default to 1.
			partialVisibilityGutter: 16,
		},
	}

	const emphasizeWidth = centerCardWidth > 0 ? centerCardWidth + 24 : 0

	return (
		<div className={styles.carouselWrapper}>
			<div className={styles.centerEmphasize} style={{ width: emphasizeWidth }} />
			<div className={styles.centerButton} style={{ width: centerCardWidth }}>
				제안하기
			</div>

			<Carousel
				className={styles.carouselContainer}
				ref={carouselContainerRef}
				partialVisbile={false}
				centerMode={false}
				swipeable={false}
				draggable={false}
				showDots={false}
				infinite={true}
				autoPlay={true}
				arrows={false}
				responsive={responsive}
				autoPlaySpeed={1000}
				keyBoardControl={true}
				transitionDuration={3000}
				containerClass="carousel-container"
				removeArrowOnDeviceType={['tablet', 'mobile']}>
				<div className={styles.profileCard}>
					<div className={styles.topLayer}>
						<div className={styles.topLayerBox}>
							가능대회목록
							<StarIcon className={styles.star} />
						</div>
					</div>
					<div className={styles.bottomLayer}>
						<div className={styles.mainProfileBox}>
							<img src="/images/profileImage1.png" className={styles.cardImage} />
							<div className={styles.wordProfile}>
								<div className={styles.wordProfileTopLayer}>
									투어/박캐디/3년/그린...
									<div className={styles.profileDetail}>프로필 상세</div>
								</div>
								<div className={styles.wordProfileMiddleLayer}>
									2024 코리아 챌린지 투어 / TOP15
								</div>
								<div className={styles.wordProfileBottomLayer}>
									<div>주급</div>
									<div>2,000,000원</div>
								</div>
							</div>
						</div>
						<ChevronDownIcon className={styles.chevronDownIcon} />
					</div>
				</div>
				<div className={styles.profileCard}>
					<div className={styles.topLayer}>
						<div className={styles.topLayerBox}>
							가능대회목록
							<StarIcon className={styles.star} />
						</div>
					</div>
					<div className={styles.bottomLayer}>
						<div className={styles.mainProfileBox}>
							<img src="/images/profileImage2.png" className={styles.cardImage} />
							<div className={styles.wordProfile}>
								<div className={styles.wordProfileTopLayer}>
									프로/심프로/9년/이글...
									<div className={styles.profileDetail}>프로필 상세</div>
								</div>
								<div className={styles.wordProfileMiddleLayer}>
									2023 마스터스 아시아 예선 / CUT 통과
								</div>
								<div className={styles.wordProfileBottomLayer}>
									<div>주급</div>
									<div>1,700,000원</div>
								</div>
							</div>
						</div>
						<ChevronDownIcon className={styles.chevronDownIcon} />
					</div>
				</div>
				<div className={styles.profileCard} ref={centerProfileCardRef}>
					<div className={styles.topLayer}>
						<div className={styles.topLayerBox}>
							가능대회목록
							<StarIcon className={styles.star} />
						</div>
					</div>
					<div className={styles.bottomLayer}>
						<div className={styles.mainProfileBox}>
							<img src="/images/profileImage3.png" className={styles.cardImage} />
							<div className={styles.wordProfile}>
								<div className={styles.wordProfileTopLayer}>
									캐디/박캐디/5년/갤럭...
									<div className={styles.profileDetail}>프로필 상세</div>
								</div>
								<div className={styles.wordProfileMiddleLayer}>
									2023 제 1회 스카이 레이크 오픈 / TOP 10
								</div>
								<div className={styles.wordProfileBottomLayer}>
									<div>주급</div>
									<div>1,800,000원</div>
								</div>
							</div>
						</div>
						<ChevronDownIcon className={styles.chevronDownIcon} />
					</div>
				</div>
				<div className={styles.profileCard}>
					<div className={styles.topLayer}>
						<div className={styles.topLayerBox}>
							가능대회목록
							<StarIcon className={styles.star} />
						</div>
					</div>
					<div className={styles.bottomLayer}>
						<div className={styles.mainProfileBox}>
							<img src="/images/profileImage4.png" className={styles.cardImage} />
							<div className={styles.wordProfile}>
								<div className={styles.wordProfileTopLayer}>
									프로/김프로/3년/무소속
									<div className={styles.profileDetail}>프로필 상세</div>
								</div>
								<div className={styles.wordProfileMiddleLayer}>
									2024 한국 내셔널 챔피언십 / 전략적 코스...
								</div>
								<div className={styles.wordProfileBottomLayer}>
									<div>주급</div>
									<div>1,500,000원</div>
								</div>
							</div>
						</div>
						<ChevronDownIcon className={styles.chevronDownIcon} />
					</div>
				</div>
				<div className={styles.profileCard}>
					<div className={styles.topLayer}>
						<div className={styles.topLayerBox}>
							가능대회목록
							<StarIcon className={styles.star} />
						</div>
					</div>
					<div className={styles.bottomLayer}>
						<div className={styles.mainProfileBox}>
							<img src="/images/profileImage5.png" className={styles.cardImage} />
							<div className={styles.wordProfile}>
								<div className={styles.wordProfileTopLayer}>
									투어/이캐디/3년/나이...
									<div className={styles.profileDetail}>프로필 상세</div>
								</div>
								<div className={styles.wordProfileMiddleLayer}>
									LPGA 투어 시드전 / 전략적 코스 매니지먼트
								</div>
								<div className={styles.wordProfileBottomLayer}>
									<div>주급</div>
									<div>2,500,000원</div>
								</div>
							</div>
						</div>
						<ChevronDownIcon className={styles.chevronDownIcon} />
					</div>
				</div>
			</Carousel>
		</div>
	)
}

export default MultiCarousel
